import React, { ReactElement } from "react"
import { AppProps } from "next/app"
import { AppData } from "../app-core/_common/app-data"
import { useInitializeECommerceMachine } from "../app-core/v3/_common/hooks/use-initialize-e-commerce-machine"
import { useUserId } from "../app-core/_common/providers/user-id-provider"
import { useServices } from "../app-core/_common/machines/machines-context"

type Props = AppProps & AppData

const CustomAppV3 = ({ Component, pageProps, appData, router }: Props): ReactElement => {
    const globalServices = useServices()
    const ecommerce = globalServices.ecommerce

    ecommerce.machine.context.flowVersion.router.useUrlSync(router, ecommerce)
    useInitializeECommerceMachine()
    useUserId()

    return <Component {...pageProps} appData={appData} />
}

export default CustomAppV3
